import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import dayjs from "dayjs";

//internal import
import PageHeader from "../../components/common/PageHeader";
import useEmployeeTrackSubmit from "../../hooks/useEmployeeTrackSubmit";
import InputArea from "../../components/Input/InputArea";
import Error from "../../components/Input/Error";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync";
import EmployeeTrackService from "../../services/EmployeeTrackService";
import DropDownService from "../../services/DropDownService";


function EmployeeTrack() {

    const [employeeTrackId, setEmployeeTrackId] = useState("");
    const { data, loading } = useAsync(() => EmployeeTrackService.getAllEmployeeTrack());
    const { data: employeeData } = useAsync(() => DropDownService.employeeDropDown());

    const {
        register,
        handleSubmit,
        errors,
        onSubmit,
        handleDeleteEmployeeTrack,
        isModal,
        setIsModal,
        isViewModal,
        setIsViewModal,
        isDeleteModal,
        setIsDeleteModal,
        viewData } = useEmployeeTrackSubmit(employeeTrackId);

    var columnsT = "";

    columnsT = [
        {
            name: "EMPLOYEE NAME",
            selector: row => <b className={row.employeeTrackName}>{row.employeeId?.employeeName}</b>,
            sortable: true
        },
        {
            name: "DATE",
            selector: row => <span className={row.txtClass}>{dayjs(row.date).format("DD-MM-YYYY")}</span>,
            sortable: true
        },
        {
            name: "TIME",
            selector: row => <span className={row.txtClass}>{row.time}</span>,
            sortable: true
        },
        {
            name: "LOCATION",
            selector: row => <span className={row.txtClass}>{row.location}</span>,
            sortable: true
        },
        {
            name: "ACTION",
            selector: () => { },
            sortable: true,
            cell: (row) => <div className="btn-group" role="group" aria-label="Basic outlined example">
                <button type="button" className="btn btn-outline-secondary" onClick={() => { setIsViewModal(true); setEmployeeTrackId(row?._id) }} ><i className="icofont-eye-alt text-primary"></i></button>
                <button type="button" className="btn btn-outline-secondary" onClick={() => { setIsModal(true); setEmployeeTrackId(row?._id); }}><i className="icofont-edit text-success"></i></button>
                <button type="button" className="btn btn-outline-secondary deleterow" onClick={() => { setIsDeleteModal(true); setEmployeeTrackId(row?._id) }} ><i className="icofont-ui-delete text-danger"></i></button>
            </div>
        }

    ]
    return (
        <div className="container-xxl">

            {loading ? <ModalLoading loading={loading} /> :
                <>
                    <PageHeader headerTitle="EmployeeTrack" renderRight={() => {
                        return <div className="col-auto d-flex w-sm-100">
                            <button className="btn btn-dark btn-set-task w-sm-100 me-2" onClick={() => { setIsModal(true); setEmployeeTrackId(""); }}><i className="icofont-plus-circle me-2 fs-6"></i>Add EmployeeTrack</button>
                        </div>
                    }} />
                    <div className="row clearfix g-3">
                        <div className="card">
                            <div className="card-body">
                                <DataTable
                                    title={"EmployeeTracks"}
                                    columns={columnsT}
                                    data={data.data}
                                    defaultSortField="title"
                                    pagination
                                    selectableRows={false}
                                    className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                    highlightOnHover={true}
                                />
                            </div>
                        </div>
                    </div>
                </>
            }

            {/* employeeTrack view modal */}
            <Modal show={isViewModal} size="lg" centered onHide={() => { setIsViewModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">EmployeeTracks Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="modal-body">
                        <div className="deadline-form">
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> EmployeeTrack Name </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.employeeId?.employeeName}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> EmployeeTrack Date </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{dayjs(viewData?.date).format("DD-MM-YYYY")}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> EmployeeTrack Time </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.time}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Location</b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.location}</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* employeeTrack add and edit modal */}
            <Modal centered show={isModal} onHide={() => { setIsModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">{employeeTrackId ? "Edit" : "Add"} EmployeeTrack</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Body>
                        <div className="mb-3">
                            <label className="form-label">Employee Name</label>
                            <select className="form-select" name="department+"
                                {...register(`employeeId`, {
                                    required: `Employee Name is required!`
                                })} >
                                <option value="" defaultValue >Select Employee</option>
                                {employeeData?.data?.map((employee, index) => (
                                    <option key={index} value={employee?.value}>{employee?.label}</option>
                                ))}
                            </select>
                            <Error errorName={errors?.employeeId} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">EmployeeTrack Date</label>
                            <InputArea register={register} name="date" type="date" className="form-control" id="exampleFormControlInput2778" />
                            <Error errorName={errors?.date} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">EmployeeTrack Time</label>
                            <InputArea register={register} name="time" type="time" className="form-control" id="exampleFormControlInput2778" />
                            <Error errorName={errors?.time} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Location</label>
                            <select className="form-select" name="department+"
                                {...register(`location`, {
                                    required: `Location is required!`
                                })} >
                                <option value="" defaultValue >Select Location</option>
                                <option value="Singapore">Singapore</option>
                                <option value="India">India</option>
                            </select>
                            <Error errorName={errors?.location} />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => { setIsModal(false) }}>Cancel</button>
                        <button type="submit" className="btn btn-primary">{employeeTrackId ? "Update " : "Add"}</button>
                    </Modal.Footer>
                </form>
            </Modal>

            {/* employeeTrack delete modal */}
            <Modal show={isDeleteModal} centered onHide={() => { setIsDeleteModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Delete EmployeeTrack</Modal.Title>
                </Modal.Header>
                <Modal.Body className="justify-content-center flex-column d-flex">
                    <i className="icofont-ui-delete text-danger display-2 text-center mt-2"></i>
                    <p className="mt-4 fs-5 text-center">Are You Sure! Want to Delete EmployeeTrack ?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsDeleteModal(false) }}>Cancel</button>
                    <button type="button" className="btn btn-danger color-fff" onClick={() => handleDeleteEmployeeTrack(employeeTrackId)}>Delete</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}


export default EmployeeTrack;